import React, { PureComponent } from "react";
import moment from "moment-timezone";

import BarChartLegendsStackedSummary from "../../BarChartLegendsStacked/BarChartLegendsStackedSummary";

import { selectFormat, Metric, Error } from "./../../Utils/Utils.js";
import Heading from "../../Elements/Heading";

class PostsSummary extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: [
      {
        Metric: "Impressions Yesterday",
        Value: selectFormat("number", this.props.data.impressions.value, "0,0"),
      },
      {
        Metric: "Posts Yesterday",
        Value: selectFormat("number", this.props.data.posts.value, "0,0"),
      },
      {
        Metric: "Engagements Yesterday",
        Value: selectFormat("number", this.props.data.engagements.value, "0,0"),
      },
      {
        Metric: "Engaged Users Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.engagedUsers.value,
          "0,0"
        ),
      },
      {
        Metric: "Engagement Rate",
        Value: selectFormat(
          "percentage",
          this.props.data.engagementRate.value,
          "%0.0"
        ),
      },
      {
        Metric: "Link Clicks",
        Value: selectFormat("number", this.props.data.linkClicks.value, "0,0"),
      },
    ],
    opts: {
      type: "other",
    },
  });

  render() {
    const { data } = this.props;

    const lastUpdated = moment
      .tz(data.now, data.cutoffTimezone)
      .format("dddd D MMM, HH:SS");
    const cutoffTime = moment
      .tz(data.cutoffTime, data.cutoffTimezone)
      .format("HH:SS");
    const tz = moment.tz(data.cutoffTime, data.cutoffTimezone).zoneAbbr();

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <>
        {lastUpdated && cutoffTime && (
          <Heading size={6} className="mb-4">
            Last updated {lastUpdated} {tz}.
            <br />
            Updated every day at {cutoffTime} {tz}.
          </Heading>
        )}
        <div className="row">
          {data.impressions && (
            <div className="col-6">
              <Heading size={6} className={"mb-1"}>
                Impressions Yesterday
              </Heading>
              <Metric {...data.impressions} size={"lg"} />
              <Heading
                size={6}
                className={"mb-1"}
                icons={data.impressions.networks}
                icons_size={"sm"}
              ></Heading>
            </div>
          )}

          {data.posts && (
            <div className="col-6">
              <Heading size={6} className={"mb-1"}>
                Posts Yesterday
              </Heading>
              <Metric {...data.posts} size={"lg"} />
              <Heading
                size={6}
                className={"mb-1"}
                icons={data.posts.networks}
                icons_size={"sm"}
              ></Heading>
            </div>
          )}

          {data.engagements && (
            <div className="col-6 mt-3 mb-3">
              <Heading size={6} className={"mb-1"}>
                Engagements Yesterday
              </Heading>
              <Metric {...data.engagements} size={"lg"} />
              <Heading
                size={6}
                className={"mb-1"}
                icons={data.engagements.networks}
                icons_size={"sm"}
              ></Heading>
            </div>
          )}

          {data.engagementRate && (
            <div className="col-6 mt-3 mb-3">
              <Heading size={6} className={"mb-1"}>
                Engagement Rate
              </Heading>
              <Metric
                {...data.engagementRate}
                size={"lg"}
                type="percentage"
                format="%0.0"
              />
              <Heading
                size={6}
                className={"mb-1"}
                icons={data.engagementRate.networks}
                icons_size={"sm"}
              ></Heading>
            </div>
          )}

          {data.engagedUsers && (
            <div className="col-6 mt-3 mb-3">
              <Heading size={6} className={"mb-1"}>
                Engaged Users Yesterday
              </Heading>
              <Metric {...data.engagedUsers} size={"lg"} />
              <Heading
                size={6}
                className={"mb-1"}
                icons={data.engagedUsers.networks}
                icons_size={"sm"}
              ></Heading>
            </div>
          )}

          {data.impressions_by_month && (
            <div className="col-6 mt-3 mb-3">
              <Heading size={6} className={"mb-1"}>
                Post Impressions By Month
              </Heading>

              <BarChartLegendsStackedSummary
                data={{ data: data.impressions_by_month, hasData: true }}
              />
            </div>
          )}

          {data.linkClicks && (
            <div className="col-6 mt-3 mb-3">
              <Heading size={6} className={"mb-1"}>
                Link Clicks
              </Heading>
              <Metric {...data.linkClicks} size={"lg"} />
              <Heading
                size={6}
                className={"mb-1"}
                icons={data.linkClicks.networks}
                icons_size={"sm"}
              ></Heading>
            </div>
          )}
        </div>
      </>
    );
  }
}

export default PostsSummary;
